import React from "react";
import "./Topbar.css";
import pin from "../../assets/pin.png";
import {
  FaFacebookF,
  FaTwitter,
  FaTiktok,
  FaPinterestP,
  FaInstagram,
} from "react-icons/fa";
import { IoLogoYoutube } from "react-icons/io";
import { FaXTwitter } from "react-icons/fa6";
const Topbar = () => {
  return (
    <div className="boots-locator">
      <div className="left-container">
        <img src={pin} alt="pin_image" className="pin_image" />

        <div className="title">
          {/* 1st Floor, Aqua Mall, Door #1A, Plot #1, Cart Track Rd, Velachery, Chennai, Tamil Nadu 600032 */}
          <a
            href="https://www.google.com/maps/place/Aqua+Mall,+Velachery,+Chennai,+Tamil+Nadu+600032"
            target="_blank"
            rel="noopener noreferrer"
            className="link-map-top"
          >
            1st Floor, Aqua Mall, Door #1A, Plot #1, Cart Track Rd, Velachery, Chennai, Tamil Nadu 600032
          </a>
        </div>
      </div>
      {/* <div className="newsletter-social">
        <a
          href="https://www.instagram.com/shamba_sync/"
          target="_blank"
          rel="noopener noreferrer"
          style={{color:"pink"}}
        >
          <FaInstagram />
        </a>
        <a
          href="https://web.facebook.com/profile.php?id=61576904680253"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary"
        >
          <FaFacebookF />
        </a>
        <a
          href="https://www.youtube.com/@Shambasynckenya"
          target="_blank"
          rel="noopener noreferrer"
          className="text-danger"

        >
          <IoLogoYoutube />
        </a>
        <a
          href="https://x.com/shambasync"
          target="_blank"
          rel="noopener noreferrer"
          className="text-dark"

        >
          <FaXTwitter />
        </a>
        <a
          href="https://www.tiktok.com/@shambasync"
          target="_blank"
          rel="noopener noreferrer"
          className="text-dark"
        >
          <FaTiktok />
        </a>
      </div> */}
    </div>
  );
};

export default Topbar;
